import { Grid2, Box } from "@mui/material";
import Loader from "Components/Common/Loader";
import ClassDetail from "Components/Classroom/ClassDetail";
import ClassList from "Components/Classroom/ClassList";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModules } from "Slices/thunks";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

const Classroom = () => {
  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => ({
    isLoading: state.Course.loading,
  })); 

  useEffect(() => {
    const courseID = localStorage.getItem('CourseID');
    dispatch(getModules({ CourseID: courseID }))

  }, [])

  return (
    isLoading ? <Loader /> :
    <Grid2 sx={styles}>
      <ClassList />
      <ClassDetail />
    </Grid2>
  );
};

export default Classroom;
